/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';

export const MASK_SHAPES = [
    { label: __('None', 'faqmate-blocks'), value: 'none' },
    { label: __('Blob', 'faqmate-blocks'), value: 'blob' },
    { label: __('Circle', 'faqmate-blocks'), value: 'circle' },
    { label: __('Hexagon', 'faqmate-blocks'), value: 'hexagon' },
    { label: __('Sketch', 'faqmate-blocks'), value: 'sketch' },
    { label: __('Triangle', 'faqmate-blocks'), value: 'triangle' }
];

export const MASK_SIZES = [
    { label: __('auto', 'faqmate-blocks'), value: 'auto' },
    { label: __('cover', 'faqmate-blocks'), value: 'cover' },
    { label: __('contain', 'faqmate-blocks'), value: 'contain' }
];

export const MASK_POSITIONS = [
    { label: __('Left Top', 'faqmate-blocks'), value: 'left top' },
    { label: __('Left Center', 'faqmate-blocks'), value: 'left center' },
    { label: __('Left Bottom', 'faqmate-blocks'), value: 'left bottom' },
    { label: __('Right Top', 'faqmate-blocks'), value: 'right top' },
    { label: __('Right Center', 'faqmate-blocks'), value: 'right center' },
    { label: __('Right Bottom', 'faqmate-blocks'), value: 'right bottom' },
    { label: __('Center Top', 'faqmate-blocks'), value: 'center top' },
    { label: __('Center Center', 'faqmate-blocks'), value: 'center center' },
    { label: __('Center Bottom', 'faqmate-blocks'), value: 'center bottom' }
];

export const MASK_REPEATS = [
    { label: __('no-repeat', 'faqmate-blocks'), value: 'no-repeat' },
    { label: __('repeat', 'faqmate-blocks'), value: 'repeat' },
    { label: __('repeat-x', 'faqmate-blocks'), value: 'repeat-x' },
    { label: __('repeat-y', 'faqmate-blocks'), value: 'repeat-y' }
];
